import { render, staticRenderFns } from "./Takeoff.vue?vue&type=template&id=81637864&scoped=true&"
import script from "./Takeoff.vue?vue&type=script&lang=js&"
export * from "./Takeoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81637864",
  null
  
)

export default component.exports